export const currencyCodes = [
  { code: 840, name: "USD" },
  { code: 978, name: "EUR" },
  { code: 980, name: "UAH" },
  { code: 826, name: "GBP" },
  { code: 392, name: "JPY" },
  { code: 756, name: "CHF" },
  { code: 156, name: "CNY" },
  { code: 784, name: "AED" },
];
